import { useState, useEffect } from 'react';
import api from '../../../services/api';
import DataTable from '../componentes/DataTable';
import EditModal from '../componentes/EditModal';
import DeleteConfirm from '../componentes/DeleteConfirm';
import { Plus } from 'lucide-react';

const ContactosPanel = () => {
  const [contactos, setContactos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const fetchContactos = async () => {
    try {
      setLoading(true);
      const res = await api.get('/contactos');
      setContactos(res.data?.data || res.data || []);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchContactos(); }, []);

  const handleEdit = (c) => {
    setSelected({ ...c });
    setShowEdit(true);
  };

  const handleCreate = () => {
    setSelected(null);
    setShowEdit(true);
  };

  const handleDelete = (id) => {
    setSelected(contactos.find(c => c.id === id));
    setShowDelete(true);
  };

  const handleSave = async (formData) => {
    if (selected) {
      await api.put(`/contactos/${selected.id}`, formData);
    } else {
      await api.post('/contactos', formData);
    }
    setShowEdit(false);
    fetchContactos();
  };

  const confirmDelete = async () => {
    await api.delete(`/contactos/${selected.id}`);
    setShowDelete(false);
    fetchContactos();
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'id_mascota', label: 'Mascota ID' },
    { key: 'tipo', label: 'Tipo' },
    { key: 'nombre', label: 'Nombre' },
    { key: 'apellido', label: 'Apellido' },
    { key: 'celular', label: 'Celular' },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 800 }}>Contactos</h1>
        <button className="sp-btn sp-btn--primary" onClick={handleCreate}>
          <Plus size={18} /> Nuevo
        </button>
      </div>

      <DataTable
        columns={columns}
        data={contactos}
        loading={loading}
        error={error}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      {showEdit && (
        <EditModal
          title={selected ? 'Editar contacto' : 'Crear contacto'}
          fields={[
            { name: 'id_mascota', label: 'ID Mascota', type: 'number' },
            { name: 'usuario_id', label: 'ID Usuario', type: 'number' },
            { name: 'tipo', label: 'Tipo (veterinario, paseador, guarderia, etc.)' },
            { name: 'categoria_personalizada', label: 'Categoría personalizada' },
            { name: 'nombre', label: 'Nombre' },
            { name: 'apellido', label: 'Apellido' },
            { name: 'celular', label: 'Celular' },
            { name: 'telefono_fijo', label: 'Teléfono fijo' },
            { name: 'direccion', label: 'Dirección' },
            { name: 'horarios', label: 'Horarios' },
            { name: 'dias_atencion', label: 'Días de atención' },
            { name: 'notas', label: 'Notas', type: 'textarea' },
            { name: 'favorito', label: 'Favorito', type: 'checkbox' },
          ]}
          initialValues={selected || {}}
          onSave={handleSave}
          onCancel={() => setShowEdit(false)}
        />
      )}

      {showDelete && (
        <DeleteConfirm
          message={`¿Eliminar el contacto ${selected.nombre}?`}
          onConfirm={confirmDelete}
          onCancel={() => setShowDelete(false)}
        />
      )}
    </div>
  );
};

export default ContactosPanel;